import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const useBackAction = (url: string) => {
    const navigate = useNavigate()

    const handleBackButton = useCallback(() => {
        navigate(url)
    }, [navigate])

    useEffect(() => {
        const backButtonListener = () => {
            handleBackButton()
        }

        window.addEventListener('popstate', backButtonListener)

        return () => {
            window.removeEventListener('popstate', backButtonListener)
        }
    }, [handleBackButton])
}
